import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';

// Порядок важен: tokens сначала, затем глобальный index.css (landing-стили).
import '@shared/design-system/tokens/tokens.css';
import '@shared/design-system/tokens/primitives.css';
import './index.css';

import reportWebVitals from '@shared/lib/reportWebVitals';
import { RouterProvider } from 'react-router';
import { router } from '@landing/router/router';
// Инициализирует i18next (side-effect import) до первого рендера.
import '@shared/i18n';
import { apolloClient } from '@app/services/apollo-client';
import { initSentry, reportWebVitalToSentry, Sentry } from '@shared/services/sentry';

initSentry();

/** Экран на случай, если рухнуло всё дерево (ErrorBoundary верхнего уровня). */
function AppCrash() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
        color: 'var(--text-primary)',
        fontFamily: 'var(--font-body)',
        padding: 24,
        textAlign: 'center',
      }}
    >
      <strong>Что-то пошло не так</strong>
      <span style={{ color: 'var(--text-secondary)' }}>
        Мы уже знаем об ошибке. Попробуйте перезагрузить страницу.
      </span>
      <button type="button" onClick={() => window.location.reload()}>
        Перезагрузить
      </button>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<AppCrash />}>
      <ApolloProvider client={apolloClient}>
        <RouterProvider router={router} />
      </ApolloProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals(reportWebVitalToSentry);
